export class admin {
  email: string;
  password: string;
}
